import styled from 'styled-components';

export const ToolbarWrapper = styled.div.attrs({
  className: 'flex gap-1 items-center',
})``;

export const ToolbarButton = styled.button.attrs({
  type: 'button',
  tabIndex: -1,
  className:
    'flex h-6 w-6 items-center justify-center rounded-md text-muted-foreground hover:bg-vantis-pastelblue data-[active=true]:bg-vantis-pastelblue data-[active=true]:text-primary disabled:pointer-events-none disabled:opacity-40',
})``;

const TOOLBAR_LABEL_VARIANT_CLASS = {
  bold: 'font-bold',
  italic: 'italic',
  underline: 'underline',
} as const;

export const ToolbarLabel = styled.span.attrs<{
  $variant: keyof typeof TOOLBAR_LABEL_VARIANT_CLASS;
}>(({ $variant }) => ({
  className: `text-xs ${TOOLBAR_LABEL_VARIANT_CLASS[$variant]}`,
}))<{ $variant: keyof typeof TOOLBAR_LABEL_VARIANT_CLASS }>``;
